var openAccordions = [];
var scroll;
var buttonMenu = null;
var buttonMenuFilter = null;
var filterItem = null;
var filterItemIndex = -1;
document.querySelector('body').addEventListener('click', (e) => {
  if (e.target.id === 'apply-filters-close-modal') {
    document.getElementById('filters-order-modal').classList.remove('is-open');
    let pageBody = document.querySelector('body');
    pageBody.classList.remove('no-overflow');
    pageBody.style.overflow = 'scroll';
    const isMargiela = document.body.dataset.sitebrand === 'Margiela';

    let html = document.getElementsByTagName('body')[0];
    if (isMargiela) {
      let menuSelector = document.querySelector('.filters-modal');
      let menuT = Number(menuSelector.dataset.lastoffset);
      html.setAttribute("style", "overflow-y: visible; position:unset;");
      $('html')[0].style.scrollBehavior = 'auto';
      window.scrollTo(0, menuT);
    }
  }
});

const setMM6Badge = () => {
  if(isMargielaBody) {
    const mmCards = document.querySelector('.product-grid-container .mm-product-card.-brand-mm');
    const mm6Cards = document.querySelector('.product-grid-container .mm-product-card.-brand-mm6');
    if(mmCards && mm6Cards) {
      $('.search-no-result-decorator-container.search-result-case').addClass('mixed-brand-search');
    } else {
      $('.search-no-result-decorator-container.search-result-case').removeClass('mixed-brand-search');
    }
  }
}

// const desktopElementsToTrigger = document.querySelectorAll(
//   '.desktop-filters .filter-list-element .js_refinement-link .selection-box',
//   '.desktop-filters .filters-close-main-container .selected-filter',
//   '.desktop-filters .filters-close-main-container .reset-filters'
// );

const updateElementsNumber = (elements) => (document.getElementById('plp-result-number') ? (document.getElementById('plp-result-number').innerText = elements) : null);
const isMargielaBody = document.querySelector('body').classList.contains('Margiela');
const isMarniBody = document.querySelector('body').dataset.sitebrand == 'Marni';

// const urlUtil = require('core/components/urlUtil');
// // const bodyScrollLock = require('body-scroll-lock/lib/bodyScrollLock');
// // const plpSwiper = require('moon/components/plpSwiper');
// // const disableBodyScroll = bodyScrollLock.disableBodyScroll;
// // const enableBodyScroll = bodyScrollLock.enableBodyScroll;
// const focusBorderWidth = 2;

// let isCurrentMobile = isMobile();

// /**
//  * Scrolls to the last seen product.
//  *
//  * @returns {void}
//  */
// function scrollToLastSeenProduct() {
//   const lastSeenProductID = new URL(window.location.href).searchParams.get('lastseen');

//   if (lastSeenProductID) {
//     const $productTile = $(`[data-pid="${lastSeenProductID}"]`).parent();

//     if ($productTile.length > 0) {
//       $('html, body').animate({ scrollTop: $productTile.offset().top - $('.js_refinements-holder').height() - 5 }, '300');
//     }
//   }
// }

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
  const $updates = $results.find(selector);
  if ($updates.length === 0) {
    $(selector).addClass('d-none');
  } else {
    $(selector).removeClass('d-none');
  }
  $(selector).empty().html($updates.html());
  // if we are in search result page trigger update-plp-cards event, that will update card and so intercept observer will work again
  if(document.querySelector('.page-search-result-container')) {
    $('body').trigger('product:update-plp-cards');
  }
}

function updateApplyButtonWithHits($results) {
  var selector = '.footer-button.apply-filters-button';
  const $updates = $results.find(selector);
  if ($updates.length !== 0) {
    var button = $(selector);
    
    if (button.length !== 0) {
      $(selector).empty().html($updates.html());
    }
  }
}

// $('.grid-x-2 ').on(
//   click(() => {
//     console.log('hi there');
//   })
// );

// /**
//  * Keep refinement panes expanded/collapsed after Ajax refresh
//  *
//  * @param {Object} $results - jQuery DOM element
//  * @return {undefined}
//  */
// function handleRefinements($results) {
//   $('.js_refinement.js_hidden-filter').each(function () {
//     const $resultFilter = $results.find(
//       '.' +
//         $(this)[0]
//           .className.replace(/ /g, '.')
//           .replace(/\b.select-open\b/g, '')
//     );

//     if ($(this).hasClass('d-lg-none')) {
//       $resultFilter.addClass('d-lg-none');
//     } else {
//       $resultFilter.removeClass('d-lg-none');
//     }
//   });
//   $('.js_refinement.select-open').each(function () {
//     if (window.innerWidth < 992) {
//       $(this).removeClass('select-open');

//       $results.find('.' + $(this)[0].className.replace(/ /g, '.')).addClass('select-open');
//     }
//   });

//   updateDom($results, '.refinements');
// }

 /**
  * Switch the grid for Internet Explorer.
  *
  * @param {number} switchTo - number of columns to switch to
  * @returns {void}
  */
 function switchIEGrid(switchTo) {
   const productGrid = document.querySelector('.js_product-grid');

   if (productGrid) {
     let columns = switchTo;

     if (!columns) {
       if (productGrid) {
         columns = productGrid.dataset.defaultGridSize;
       } else {
         return;
       }
     }

     const tiles = document.querySelectorAll('.js_tile');
     let maxRow = 0;
     let tile;

     for (let i = 0; i < tiles.length; i++) {
       tile = tiles[i];
       tile.style.msGridColumn = tile.dataset['gridColumn-' + columns];
       tile.style.msGridRow = tile.dataset['gridRow-' + columns];
       maxRow = Math.max(maxRow, tile.dataset['gridRow-' + columns]);
     }

     // The rows height. The first auto is the height of the first item. After that it is
     // repeated the gap between rows and the next row until the end of the max row
     // At the end there is one more gap+row for the grid footer.
     if (isMobile()) {
       productGrid.style.msGridRows = 'auto (14px auto)[' + ((maxRow + 1) / 2).toFixed() + ']';
     } else {
       productGrid.style.msGridRows = 'auto (28px auto)[' + ((maxRow + 1) / 2).toFixed() + ']';
     }

     const gridFooter = document.querySelector('.js_grid-footer');

     if (gridFooter) {
       gridFooter.style.msGridRow = maxRow + 2;
     }
   }
 }

// /**
//  * Update the URL hash with the current AJAX url. This allows to go back on the same
//  * page and to re-apply the filters.
//  *
//  * @param {string} currentUrl - the current URL
//  * @param {Object} options - the additional parameters to add to URL
//  * @returns {void}
//  */
function updateHash(currentUrl, options) {
  let url = new URL(currentUrl, window.location.origin);
  const paramKeys = Object.keys(options);

  for (let i = 0; i < paramKeys.length; i++) {
    url.searchParams.set(paramKeys[i], options[paramKeys[i]]);
  }

  window.history.pushState({}, '', url.search);
}


function updateHashNew(currentUrl, options) {
  var url = new URL(currentUrl, window.location.origin);
  var newURL = url.origin + options.updateURL;
  
  window.history.replaceState({}, '', newURL);
}


// /**
//  * Attach handlers to grid columns switch.
//  *
//  * @returns {void}
//  */
// function toggleColumnsGrid() {
//   const toggleValues = document.querySelectorAll('.js_column-toggle-value');

//   for (let i = 0; i < toggleValues.length; i++) {
//     toggleValues[i].addEventListener('click', function (e) {
//       const otherToggles = document.querySelectorAll(".js_column-toggle-value:not([data-columns='" + e.target.dataset.columns + "'])");
//       const container = document.querySelector('.js_product-grid');
//       container.dataset.currentGridSize = e.target.dataset.columns;
//       let item = null;

//       for (let j = 0; j < otherToggles.length; j++) {
//         item = otherToggles[j];
//         item.classList.remove('active', 'js_active');
//         container.classList.remove('product-grid-' + item.dataset.columns);
//       }

//       e.target.classList.add('active', 'js_active');

//       if (isIE11) {
//         switchIEGrid(e.target.dataset.columns);
//       }

//       updateHash(window.location.href, {
//         lastAction: 'grid',
//         grid: e.target.dataset.columns,
//       });
//       container.classList.add('product-grid-' + e.target.dataset.columns);
//     });

//     if (toggleValues[i].classList.contains('js_active')) {
//       if (isIE11) {
//         switchIEGrid(toggleValues[i].dataset.columns);
//       }

//       const container = document.querySelector('.js_product-grid');

//       if (toggleValues[i].classList.contains('js_default') && container.dataset.currentGridSize && container.dataset.currentGridSize !== toggleValues[i].dataset.columns) {
//         updateHash(window.location.href, {
//           lastAction: 'grid',
//           grid: container.dataset.currentGridSize,
//         });
//       }
//     }
//   }
// }

// /**
//  * Show the additional hidden filters
//  */
// function showMoreFilters() {
//   const moreFilters = document.querySelector('.js_more-filters');

//   if (moreFilters) {
//     const lessFilters = document.querySelector('.js_less-filters');

//     const moreFiltersAction = function () {
//       const hiddenFilters = document.querySelectorAll('.js_hidden-filter');
//       hiddenFilters.forEach(function (item) {
//         item.classList.remove('d-lg-none');
//       });
//       moreFilters.classList.toggle('d-lg-none');
//       lessFilters.classList.toggle('d-lg-none');

//       if (hiddenFilters.length > 0) {
//         hiddenFilters[0].querySelector('.js_card-header').focus();
//       }

//       scrollToRefinementBar();
//     };

//     const lessFiltersAction = function () {
//       const shownFilters = document.querySelectorAll('.js_hidden-filter');
//       shownFilters.forEach(function (item) {
//         item.classList.add('d-lg-none');
//       });
//       moreFilters.classList.toggle('d-lg-none');
//       lessFilters.classList.toggle('d-lg-none');
//       scrollToRefinementBar();
//     };

//     moreFilters.addEventListener('click', moreFiltersAction, false);
//     moreFilters.addEventListener(
//       'keyup',
//       function (e) {
//         if (e.key === 'Enter' || e.key === ' ') {
//           moreFiltersAction(e);
//         }
//       },
//       false
//     );

//     lessFilters.addEventListener('click', lessFiltersAction, false);
//     lessFilters.addEventListener(
//       'keyup',
//       function (e) {
//         if (e.key === 'Enter' || e.key === ' ') {
//           lessFiltersAction(e);
//         }
//       },
//       false
//     );
//   }
// }


function removeParam(key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
              params_arr.splice(i, 1);
          }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response, updateNewURL) {
  const $results = $(response);
  if (isMarniBody){
    for (var i = 0; i < openAccordions.length; i++) {
      $('.single-filter-section.' + openAccordions[i])[0].classList.add('is-visible');
      $('.single-filter-section.' + openAccordions[i])[0].classList.add('is-active');
      $('.single-filter-section.' + openAccordions[i])[0].classList.add('no-animation');

      var label = '.single-filter-section.' + openAccordions[i];
      var results = $results.find(label);

      if (results[0]) {
        results[0].classList.add('is-visible');
        results[0].classList.add('is-active');
        results[0].classList.add('no-animation');
      }
    }
    openAccordions = [];

    updateApplyButtonWithHits($results);
  }

  if (!isMargielaBody && !isMarniBody){
    // Update DOM elements that do not require special handling
    ['.js-desktop-filters', '.modal-filters-order', '.refinement-bar', '.js-mobile-sort', '.selected-filters', '.grid-product'].forEach(function (selector) {
      updateDom($results, selector);
    });
  } else if (isMarniBody && updateNewURL) {
    // Update DOM elements that do not require special handling
    ['.js-desktop-filters', '.single-filter-section.gender .js-accordion-content', '.single-filter-section.gender .button-open-filter','.single-filter-section.ecomProductGroup .js-accordion-content', '.single-filter-section.ecomProductMainGroup .js-accordion-content', '.single-filter-section.ecomProductGroup .button-open-filter','.single-filter-section.ecomProductMainGroup .button-open-filter','.single-filter-section.availableInStores .js-accordion-content','.single-filter-section.availableInStores .button-open-filter','.single-filter-section.macroColor .js-accordion-content','.single-filter-section.macroColor .button-open-filter','.single-filter-section.size .js-accordion-content','.single-filter-section.size .button-open-filter' , '.refinement-bar', '.js-mobile-sort', '.selected-filters', '.grid-product', '.category-menu-top-container', '.category-menu-top-title-mobile', '.category-bottom-banner'].forEach(function (selector) {
      updateDom($results, selector);
    });
  } else if((isMarniBody && !updateNewURL) || isMargielaBody){
    // Update DOM elements that do not require special handling
    ['.js-desktop-filters', '.single-filter-section.gender .js-accordion-content', '.single-filter-section.gender .button-open-filter','.single-filter-section.ecomProductGroup .js-accordion-content', '.single-filter-section.ecomProductGroup .button-open-filter','.single-filter-section.ecomProductMainGroup .js-accordion-content', '.single-filter-section.ecomProductMainGroup .button-open-filter','.single-filter-section.availableInStores .js-accordion-content','.single-filter-section.availableInStores .button-open-filter','.single-filter-section.macroColor .js-accordion-content','.single-filter-section.macroColor .button-open-filter','.single-filter-section.size .js-accordion-content','.single-filter-section.size .button-open-filter' , '.refinement-bar', '.js-mobile-sort', '.selected-filters', '.grid-product'].forEach(function (selector) {
      updateDom($results, selector);
    });
  }


  //$('.search-no-result-decorator-container').replaceWith(response);
}

 /**
  * Update sort option URLs from Ajax response
  *
  * @param {string} response - Ajax response HTML code
  * @return {undefined}
  */
 function updateSortOptions(response) {
   const $tempDom = $('<div>').append($(response));
   const sortOptions = $tempDom.find('.js_grid-footer').data('sort-options').options;
   sortOptions.forEach(function (option) {
     $('option.' + option.id).val(option.url);
   });
 }

// /**
//  * Updates the filer URLs with the sorting rule.
//  * Works with elements that have either an [href]
//  * attribute or an [data-href] attribute.
//  * @param {string} sortId - the sorting rule id
//  */
// function updateFiltersSortUrl(sortId) {
//   const $refLinks = $('.js_refinement-link, .filter-bar a, .clear-apply-wrapper a');
//   let $refLink;
//   let href;
//   let updatedHref;
//   let isHref;

//   for (let i = 0; i < $refLinks.length; i++) {
//     $refLink = $($refLinks[i]);

//     isHref = !!$refLink.attr('href');

//     if (isHref) {
//       href = $refLink.attr('href');
//     } else {
//       href = $refLink.attr('data-href');
//     }

//     updatedHref = urlUtil.getUrlWithNewParameter('srule', sortId, href, '');

//     if (isHref) {
//       $refLink.attr('href', updatedHref);
//     } else {
//       $refLink.attr('data-href', updatedHref);
//     }
//   }
// }

 /**
  * Show the load more spinner and hide the button and label
  */
 function loadMoreShowSpinner() {
   const $showMore = $('.js_show-more');
   $showMore.find('.js_you-have-seen').hide();
   $showMore.find('.js_button-load-more').hide();
   $showMore.find('.js_show-more-spinner').show();
 }

 /**
  * Show the load more button and label and hide the spinner
  */
 function loadMoreHideSpinner() {
   const $showMore = $('.js_show-more');
   $showMore.find('.js_you-have-seen').show();
   $showMore.find('.js_button-load-more').show();
   $showMore.find('.js_show-more-spinner').hide();
 }

 /**
  * Check if the pagination should be updated - in case the returning back to PLP which shows
  * more than one page.
  *
  * @returns {Object} - object containing the URL to call and the start number of the last
  *      page to be shown
  */
 function checkAutoloadMore() {
   const loadMoreButton = document.querySelector('.js_search-results .js_button-load-more');

   if (loadMoreButton) {
     const showMoreUrl = new URL(loadMoreButton.dataset.url, window.location.origin);
     const url = new URL(window.location.hash.replace('#', ''), window.location.origin);
     const startParam = url.searchParams.get('untilStart');

     if (startParam && startParam !== '') {
       const nextStart = showMoreUrl.searchParams.get('start');

       if (nextStart && parseInt(nextStart, 10) <= parseInt(startParam, 10)) {
         return {
           showMoreUrl: showMoreUrl.toString(),
           untilStart: startParam,
         };
       }
     }
   }

   return false;
 }

 /**
  * Call AJAX to show more results.
  *
  * @param {string} showMoreUrl - the URL of show more
  * @param {number} allowAutoload - if set will try to load even more pages until the index of the first
  * @param {string} callback - optional callback name
  * result of the requested page is more than the hash's untilStart parameter
  * @returns {void}
  */
 function ajaxShowMore(showMoreUrl, allowAutoload, callback) {
   $.ajax({
     url: showMoreUrl,
     data: { selectedUrl: showMoreUrl },
     method: 'GET',
     success: function (response) {
       $('.js_grid-footer').replaceWith(response);
       const autoloadMore = checkAutoloadMore();

       if (allowAutoload) {
         if (autoloadMore) {
           ajaxShowMore(autoloadMore.showMoreUrl, autoloadMore.untilStart, callback);
         }
       } else {
         const newStart = new URL(showMoreUrl, window.location.origin).searchParams.get('start');
         updateHash(showMoreUrl, {
           lastAction: 'showMore',
           untilStart: newStart,
         });
       }

       updateSortOptions(response);

       if (callback && !(allowAutoload && autoloadMore)) {
         callback();
       }

       loadMoreHideSpinner();
     },
     error: function () {
       if (callback) {
         callback();
       }

       loadMoreHideSpinner();
     },
   });
 }

/**
 * Call AJAX to apply filters.
 *
 * @param {string} url - the URL for applying filters
 * @param {boolean} autoApply - auto apply url filers or cta from a button
 * @param {string} updateNewURL - optional callback name
 * @returns {void}
 */
function ajaxApplyFilter(url, autoApply, updateNewURL) {
  scroll = $('.modal-filters-order .modal-content')[0].scrollTop;
  $.ajax({
    url: url,
    data: {
      page: $('.grid-footer').data('page-number'),
      selectedUrl: url,
    },
    method: 'GET',
    success: function (response) {
      parseResults(response, updateNewURL);
      if (updateNewURL) {
        updateHashNew(url, {
          updateURL: updateNewURL,
        });
        let names = [];
        let skus = [];
        let product = $('.product-grid-container .product');
        for (let i = 0; i < product.length; i++) {
          if (product[i].dataset.productName) {
            names.push(product[i].dataset.productName);
          }
          if (product[i].dataset.pid) {
            skus.push(product[i].dataset.pid);
          }
        }
        window.SubCategoryList_track({

          page_category : $('.category-menu-top-categories-category.selected')[0].id,
          
          product_impression_sku : skus,
          
          product_impression_name : names
          
          });

      } else {
        updateHash(url, {
          lastAction: 'applyFilter',
        });
      }

      var totalElements = document.getElementsByClassName('js_you-have-seen').length > 0 ? document.getElementsByClassName('js_you-have-seen')[0].dataset.productcount  : document.querySelectorAll('.product-grid-container .single-element').length;
      updateElementsNumber('' + totalElements);
      document.querySelector('.results-label').innerText = totalElements;
      $.spinner().stop();
      $.event.trigger({
        type: 'appliedFilter',
        url: url,
      });
      updateGridSize();
      if (window.innerWidth < 992 || isMargielaBody) {
        let layoutType =  isMargielaBody ? 'multi' : document.querySelector('.js-change-view-toggle.active').getAttribute('data-layout');
        let classLayout = layoutType === 'multi' ? 'product-x-2' : 'product-x-1';
        document.querySelector('.js-product-grid-container').classList.remove('product-x-2');
        document.querySelector('.js-product-grid-container').classList.remove('product-x-1');
        document.querySelector('.js-product-grid-container').classList.add(classLayout);
      }
      setMM6Badge();

      // IBT-4014
      $('body').trigger('product:update-plp-cards');
      if (isMargielaBody) {
        const refinementsTitle = document.querySelector('.modal-filters-order .title-wrapper');
        var nFilters = getComputedStyle(document.documentElement).getPropertyValue('--content-filters');
        var filters = nFilters.replace(/\D/g, '');
        if (parseInt(filters) > 0) {
          refinementsTitle.classList.add('-dot-info');
        } else {
          refinementsTitle.classList.remove('-dot-info');
        }
      }

      if (isMarniBody){
        let activeFiltersTotal = $('.selected-box').length / 2;

        let sortOrderLength = $('.order-by-radios.js-mobile-sort .radio').length;
        let changed = false; 
        for (let i = 0; i < sortOrderLength; i++) {
          let selector = document.querySelectorAll('.order-by-radios.js-mobile-sort .radio')[i].children[0];
          if (selector.checked) {
            if (selector.value != $('.mobile-filters .filters-order-button')[0].dataset.lastSort) {
              $('.mobile-filters .filters-order-button')[0].dataset.lastSort = selector.value;
              changed = true;
            }
          }
        }

        if (activeFiltersTotal > 0 || changed) {
          if(activeFiltersTotal > 0) {
            document.querySelector('.active-filters-number').innerText = ' (' + activeFiltersTotal + ')';
          }
          document.getElementById('filters-order-modal').classList.add('active-filters');
          // $('.modal-filters-order .modal-footer');
        } else {
          document.querySelector('.active-filters-number').innerText = '';
          document.getElementById('filters-order-modal').classList.remove('active-filters');
        }
        $('.apply-filters-button').removeClass('button--loading');
      }

      if(isMarniBody && !window.isMobile() && buttonMenuFilter) {
        $('.js-dropdown-trigger.last-aplied-menu').length > 0 ?  $('.js-dropdown-trigger.last-aplied-menu').removeClass('last-aplied-menu') : '';
        var lastSelected = $('div.dropdown').find("[data-filter-bar='" + buttonMenuFilter + "']").addClass('last-aplied-menu');
        lastSelected.attr('data-filter-index', filterItemIndex);
      } 
      var isNewPLP = false;
      if ($('.new-page-search-result').length > 0) {
        isNewPLP = true;
      }
      if (isNewPLP) {
        $('.skeleton-loader').addClass('d-none');     
        $('.search-result.js_search-results .grid-product').removeClass('d-none');   
      }  
    },
    error: function () {
      $.spinner().stop();
      if (isMarniBody){
        $('.apply-filters-button').removeClass('button--loading');
      }
    },
  });
}


function scrollFunction(isScrollUp) {
  mybutton = $('.back-to-top');
  if (mybutton.length > 0) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20 && !document.querySelector('#dynamic-modal.is-open')
      && (isMargielaBody ? isScrollUp : window.innerWidth >= 992)) // visible on scroll up both mobile and desktop for MM and only desktop for Marni
    {
      mybutton[0].style.visibility = "visible";
      mybutton[0].style.opacity = "1";

      // Align back to top button with header notification banner
      if (isMargielaBody && document.getElementsByClassName('header-notification-slot-container').length) {
        let bannerHeight = 0
        document.querySelectorAll('.header-notification-slot-container').forEach( banner => {
          bannerHeight += banner.clientHeight;
        });
        mybutton[0].style.top = (85 + bannerHeight).toFixed() + 'px';
      }
    } else {
      mybutton[0].style.visibility = "hidden";
      mybutton[0].style.opacity = "0";
    }
  }
}

function getCustomerWishlist() {
  let url = document.querySelector('.js-button-wishlist') ? document.querySelector('.js-button-wishlist').getAttribute('data-customer-wishlist-products') : null;
  
  if(url){
  $.ajax({
    url: url,
    method: 'GET',
    success: function (responseData) {
      if(responseData) {
        $('.js_add-to-wish-list.active').removeClass('active');
        if(responseData.wishlistIDS && responseData.wishlistIDS.length > 0) {
          responseData.wishlistIDS.forEach(function(item) {
            $(".js_add-to-wish-list[data-pid=" + item + "]").addClass('active');
          });
        }
      }
    },
    error: function () {
      console.log('Error while getting notify content');
    },
  });
}
}


// /**
//  * Call AJAX to sort results.
//  *
//  * @param {string} url - the URL for sorting
//  * @param {string} newLabel - the new label of the sorting selection
//  * @param {string} sortId - the new id of the sorting selection
//  * @param {string} callback - optional callback name
//  * @returns {void}
//  */
// function ajaxSort(url, newLabel, sortId, callback) {
//   $.ajax({
//     url: url,
//     data: { selectedUrl: url },
//     method: 'GET',
//     success: function (response) {
//       $('.sort-selected-option').text(newLabel);
//       $('.js_product-grid').empty().html(response);
//       updateHash(url, {
//         lastAction: 'sort',
//         newLabel: newLabel,
//         sortId: sortId,
//       });
//       const autoloadMore = checkAutoloadMore();

//       if (autoloadMore) {
//         ajaxShowMore(autoloadMore.showMoreUrl, autoloadMore.untilStart, callback);
//       }

//       updateFiltersSortUrl(sortId);

//       if (callback && !autoloadMore) {
//         callback();
//       }

//       if (isMobile()) {
//         document.getElementById(sortId).checked = true;
//       }

//       $.spinner().stop();
//     },
//     error: function () {
//       if (callback) {
//         callback();
//       }

//       $.spinner().stop();
//     },
//   });
// }

// /**
//  * Apply the hash when lending on the page. The hash might contain the previously filtering and sorting options.
//  *
//  * @returns {void}
//  */
// function applyHash() {
//   const url = new URL(window.location.hash.replace('#', ''), window.location.origin);
//   const grid = url.searchParams.get('grid');

//   if (grid) {
//     const toggleGrid = document.querySelector(".js_column-toggle-value[data-columns='" + grid + "']");

//     if (toggleGrid) {
//       toggleGrid.click();
//     }
//   }

//   const lastAction = url.searchParams.get('lastAction');

//   if (lastAction === 'applyFilter') {
//     $.spinner().start();
//     ajaxApplyFilter(url.toString(), true, scrollToLastSeenProduct);
//   } else if (lastAction === 'sort') {
//     ajaxSort(url.toString(), url.searchParams.get('newLabel'), url.searchParams.get('sortId'), scrollToLastSeenProduct);
//   } else if (lastAction === 'showMore') {
//     const autoloadMore = checkAutoloadMore();

//     if (autoloadMore) {
//       ajaxShowMore(autoloadMore.showMoreUrl, autoloadMore.untilStart, scrollToLastSeenProduct);
//     }
//   } else {
//     scrollToLastSeenProduct();
//   }
// }

// /**
//  * This function retrieves another page of content to display in the content search grid
//  * @param {JQuery} $element - the jquery element that has the click event attached
//  * @param {JQuery} $target - the jquery element that will receive the response
//  * @return {undefined}
//  */
// function getContent($element, $target) {
//   const showMoreUrl = $element.data('url');
//   $.spinner().start();
//   $.ajax({
//     url: showMoreUrl,
//     method: 'GET',
//     success: function (response) {
//       $target.append(response);
//       $.spinner().stop();
//     },
//     error: function () {
//       $.spinner().stop();
//     },
//   });
// }

// /**
//  * Animate scroll to specific position of the page. (Copied from custom_diesel_storefront)
//  * @param {number} to - the y position of the page where to scroll to
//  * @param {number} animationFrames - number of animation frames to use durning scrolling
//  */
// function animateScroll(to, animationFrames) {
//   const targetHeight =
//     document.body.scrollHeight - window.innerHeight > to + window.scrollY ? to - focusBorderWidth : document.body.scrollHeight - window.innerHeight + focusBorderWidth;
//   const initialPosition = window.scrollY;
//   const stepDistance = Math.PI / animationFrames;
//   let stepCount = 0;
//   /**
//    * The step function of the animation. On every frame this function will be executed.
//    *
//    * @returns {void}
//    */
//   function step() {
//     if (stepCount < animationFrames) {
//       requestAnimationFrame(step);
//       stepCount++;
//       window.scrollTo(0, initialPosition + targetHeight * 0.25 * Math.pow(1 - Math.cos(stepDistance * stepCount), 2));
//     }
//   }
//   requestAnimationFrame(step);
// }

// /**
//  * Scroll to the top of the refinement bar.(Copied from custom_diesel_storefront)
//  */
// function scrollToRefinementBar() {
//   const refinementBar = document.querySelector('.js_refinement-bar');
//   animateScroll(refinementBar.getBoundingClientRect().top, 30);
// }

// /**
//  * Hides the more filters label, shows the less filters label and scroll to refinement bar
//  */
// function moreFiltersAction() {
//   const $hiddenFilters = $('.js_hidden-filter');
//   $hiddenFilters.removeClass('d-lg-none');

//   $('.js_more-filters').addClass('d-lg-none');
//   $('.js_less-filters').removeClass('d-lg-none');

//   $hiddenFilters.find('.js_card-header').focus();
//   scrollToRefinementBar();
// }

// /**
//  * Shows the more filters label, hides the less filters label and scroll to refinement bar
//  */
// function lessFiltersAction() {
//   const $shownFilters = $('.js_hidden-filter');
//   $shownFilters.addClass('d-lg-none');

//   $('.js_more-filters').removeClass('d-lg-none');
//   $('.js_less-filters').addClass('d-lg-none');

//   scrollToRefinementBar();
// }

function updateGridSize() {
  if (screen.width < 992) {
    document.querySelector('.product-grid-container').classList.add('product-x-2');
  } else {
    if (document.querySelector('.product-grid-container') && document.querySelector('.product-grid-container').classList.contains('product-x-2')) {
      document.querySelector('.product-grid-container').classList.remove('product-x-2');
    }
  }
}

module.exports = {
  //   tilesClick: function () {
  //     $('body').on('click', '.tile-image-link, product-link', (e) => {
  //       const pid = $(e.currentTarget).parents('.product').data('pid');

  //       if (pid) {
  //         let currentHref = window.location.href;
  //         let searchHistoryURL = '';
  //         if (currentHref.indexOf('lastseen=') >= 0) {
  //           searchHistoryURL = currentHref.replace(/lastseen\=[\d\w_]+/, `lastseen=${pid}`);
  //         } else {
  //           const queryStringSign = currentHref.indexOf('?') === -1 ? '?' : '&';
  //           searchHistoryURL = currentHref + queryStringSign + 'lastseen=' + pid;
  //         }
  //         window.history.pushState({}, window.document.title, searchHistoryURL);
  //       }
  //     });
  //   },
  //   showMoreFilters: () => {
  //     $body.on('click', '.js_more-filters', moreFiltersAction);
  //     $body.on('click', '.js_less-filters', lessFiltersAction);

  //     $body.on('keyup', '.js_more-filters', (event) => {
  //       if (event.key !== 'Enter' || event.key !== ' ') return;
  //       moreFiltersAction();
  //     });
  //     $body.on('keyup', '.js_less-filters', (event) => {
  //       if (event.key !== 'Enter' || event.key !== ' ') return;
  //       lessFiltersAction();
  //     });
  //   },
  //   searchAgain: function () {
  //     const noResults = $body.find('.noresults-wrapper');

  //     if (noResults && noResults.length > 0) {
  //       $('.js_search-link').click();
  //     }
  //   },
  //   scrollTop: function () {
  //     const backToTop = document.querySelector('.back-to-top-box');
  //     if (!!window.IntersectionObserver) {
  //       const observer = new IntersectionObserver(
  //         ([entry]) => {
  //           if (entry.intersectionRect.top <= 0) {
  //             backToTop.classList.add('enabled');
  //           } else {
  //             backToTop.classList.remove('enabled');
  //           }
  //         },
  //         {
  //           root: null,
  //           threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
  //         }
  //       );
  //       observer.observe(document.querySelector('.js_search-results'));
  //     } else {
  //       $(window).scroll(function () {
  //         if ($(window).scrollTop() > 150) {
  //           backToTop.fadeIn('slow');
  //         } else {
  //           backToTop.fadeOut('slow');
  //         }
  //       });
  //     }
  //     backToTop.addEventListener('click', () => {
  //       window.scrollTo({ top: 0, behavior: 'smooth' });
  //     });
  //   },

  showMore: function () {
    // Show more products
    $('.js_search-results').on('click', '.js_button-load-more', function (e) {
      e.stopPropagation();
      const firstGridContainer = document.querySelector('.grid-product .js-product-grid-container');
      const showMoreUrl = $(this).data('url');
      e.preventDefault();
      loadMoreShowSpinner();
      ajaxShowMore(showMoreUrl, undefined, function () {
        let appliedFilters = $('.filter-clearall-secondary').data('filterlenght');
        if(window.innerWidth < 992 && !isMargielaBody) {
          document.querySelectorAll('.grid-product .js-product-grid-container').forEach( grid => {
            if(!grid.classList.contains('product-x-1') && !grid.classList.contains('product-x-2')) {
              grid.classList.remove('row');
              grid.classList.remove('product-grid-container');
              grid.classList.remove('js-product-grid-container');
              grid.classList.add('parent-to-be-removed');
              const parentContent = $(".parent-to-be-removed").contents();
              firstGridContainer.appendChild(grid);
              $(".parent-to-be-removed").replaceWith(parentContent);
            }
          });
        } else {
          document.querySelectorAll('.grid-product .js-product-grid-container').forEach( (grid, index) => {
            if(index !== 0) {
              grid.classList.remove('row');
              grid.classList.remove('product-grid-container');
              grid.classList.remove('js-product-grid-container');
              grid.classList.add('parent-to-be-removed');
              const parentContent = $(".parent-to-be-removed").contents();
              firstGridContainer.appendChild(grid);
              $(".parent-to-be-removed").replaceWith(parentContent);
            }
          });
        }
        if (typeof appliedFilters == 'undefined' || appliedFilters == 0) {
          $('body').trigger('product:listing-show-more');
        }
        const interceptBottom = document.querySelectorAll('.intercept-trigger.bottom-position');
        interceptBottom.length > 1 ? document.querySelectorAll('.intercept-trigger.bottom-position')[1].remove() : null;
        $('body').trigger('product:update-plp-cards');
        setMM6Badge();
    });
    if(isMargielaBody) {
      getCustomerWishlist();
    }
  });

  window.onscroll = function() {
    if(isMargielaBody) {
      scrollFunction(this.oldScroll > this.scrollY);
      this.oldScroll = this.scrollY;
      //BOTTOM
      var someElement = $('.filters-bar');
      if ($('.mobile-filter-top').length > 0) {
        if(someElement[0].getBoundingClientRect().bottom <= 0 ){
          $('.mobile-filter-top')[0].style.display = "block";
        }
        if(someElement[0].getBoundingClientRect().bottom >= 0){
          $('.mobile-filter-top')[0].style.display = "none";
        }
      }
    }
  };

  $('body').on('click', '.back-to-top', function() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  });


  $('body').on('click', '.apply-filters-button', function() {
    if(isMarniBody) {
      $('#filters-order-modal .modal-close').click();
    }
  });
},
  //   filter: function () {
  //     // Display refinements bar when Menu icon clicked
  //     $('.container').on('click', 'button.filter-results', function () {
  //       $('.refinement-bar, .modal-background').show();
  //     });
  //   },

  //   closeRefinments: function () {
  //     // Refinements close button
  //     $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
  //       $('.refinement-bar, .modal-background').hide();
  //     });
  //   },

  applyFilter: function () {
    // Handle refinement value selection and reset click
    $('body').on('click', '.js_refinement-link, .js_filter-remove, .js-filter-reset', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $.spinner().start();
      var isNewPLP = false;
      if ($('.new-page-search-result').length > 0) {
        isNewPLP = true;
      }
      var updateNewURL = false;
      if (isMarniBody) {
        if (!isNewPLP) {
          let html = document.getElementsByTagName('body')[0];
          html.setAttribute("style", "overflow-y: scroll;position:unset;");
        } else {
          if (e.currentTarget.classList.contains('category-menu-top-categories-category')) {
            if (e.currentTarget.dataset.alternativeUrl) {
              var alternativeUrl = e.currentTarget.dataset.alternativeUrl;
              var categoryID = alternativeUrl.split('marni.com')[1];
              // var locale = alternativeUrl.substring(alternativeUrl.indexOf('marni.com/') + 10, alternativeUrl.indexOf('marni.com/') + 15);
              updateNewURL = categoryID;
            } else {
              updateNewURL = e.currentTarget.dataset.url;
            }
            if (window.isMobile()) {
              var selectedItem = $(this);

              selectedItem[0].scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
            }

            $('.category-menu-top-categories').find('.selected').removeClass('selected');
            e.currentTarget.classList.add('selected');
            $('.skeleton-loader').removeClass('d-none');
            $('.search-result.js_search-results .grid-product').addClass('d-none');
            if (window.scrollY > 200) {
              $("html, body").animate({ scrollTop: 0 }, "slow"); 
            }
          }
        }
      } else if (isMargielaBody && !e.currentTarget.classList.contains('selected-box')) {
        let html = document.getElementsByTagName('body')[0];
        html.setAttribute("style", "overflow-y: scroll;position:unset;");
        $("html, body").animate({ scrollTop: 0 }, "slow");
        let menuSelector = document.querySelector('.filters-modal');
        menuSelector.dataset.lastoffset = 0;
      }
      buttonMenu = null;
      buttonMenuFilter = null;
      filterItem = null;
      if (isMarniBody){
        if (e.currentTarget.classList.contains('js_refinement-link') && !e.currentTarget.classList.contains('category-menu-top-categories-category')) {
          if (e.currentTarget.classList.contains('selected')) {
            e.currentTarget.classList.remove('selected');
            e.currentTarget.children[0].classList.remove('selected-box');
          } else {
            e.currentTarget.classList.add('selected');
            e.currentTarget.children[0].classList.add('selected-box');
          }
        }
        if (e.currentTarget.classList.contains('js-filter-reset')) {
          $('.js_refinement-link .selected-box').removeClass('selected-box');
          $('.js_refinement-link.selected').removeClass('selected');
        }
        $('.apply-filters-button').addClass('button--loading');
        if (!e.currentTarget.classList.contains('js-filter-reset')) {
          var accordions= $('.single-filter-section').length;
          for (var i = 0; i < accordions; i++) {
            if($('.single-filter-section')[i].classList.contains('is-active')) {
              openAccordions.push($('.single-filter-section')[i].dataset.filter);
            }
          }
        } else {
          accordions = [];
        }
      }
      
      $(this).trigger('search:filter', e);
      let url = e.currentTarget.getAttribute('data-href');
      if (!url) {
        url = e.currentTarget.getAttribute('href');
      }

     if(isMarniBody && !isNewPLP && !window.isMobile() && e.currentTarget.classList.contains('js_refinement-link') && !e.currentTarget.classList.contains('category-menu-top-categories-category')) {
        buttonMenu =  e.currentTarget.closest('.filter-list-element').querySelector('.js-dropdown-trigger');
        var index = Array.from(e.currentTarget.parentNode.parentNode.children).indexOf(e.currentTarget.parentNode);
        filterItemIndex = index;
        e.currentTarget.classList.add('applied-filter-item'); 
      }

     buttonMenuFilter = $(buttonMenu).length ?  $(buttonMenu)[0].dataset.filterBar : null;
   
      ajaxApplyFilter(url, false, updateNewURL);
    });
  },

  applySort: function () {
    // Handle refinement value selection and reset click
    $('body').on('click change', '.js_d-order-radio, .js_m-order-radio', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $.spinner().start();
      if (isMarniBody){
        $('.apply-filters-button').addClass('button--loading');
        var accordions= $('.single-filter-section').length;
        for (var i = 0; i < accordions; i++) {
          if($('.single-filter-section')[i].classList.contains('is-active')) {
            openAccordions.push($('.single-filter-section')[i].dataset.filter);
          }
        }
      }
      $(this).trigger('search:filter', e);
      let url = e.currentTarget.getAttribute('data-href');
      if (isMargielaBody) {
        if (e.currentTarget.classList.contains('checked')) {
          url = removeParam("srule", url);
          e.currentTarget.classList.remove('checked');
        } else {
          e.currentTarget.classList.add('checked');
        }
      }

      if (!url) {
        url = e.currentTarget.getAttribute('href');
      }

      ajaxApplyFilter(url, false);
    });
  },

  scrolToFirstBreadcrumb: function() {
    document.body.dataset.sitebrand === 'Margiela' && document.getElementById("breadcrumb") ? document.getElementById("breadcrumb").scrollLeft = 0 : '';
  },

  onReady: function() {
    let activeFiltersTotal = $('.selected-box').length / 2;
    if (isMarniBody && $('.product-set-category').length == 0) {
      if (activeFiltersTotal > 0) {
        document.querySelector('.active-filters-number').innerText = ' (' + activeFiltersTotal + ')';
        document.getElementById('filters-order-modal').classList.add('active-filters');
        // $('.modal-filters-order .modal-footer');
      } else {
        document.querySelector('.active-filters-number').innerText = '';
        document.getElementById('filters-order-modal').classList.remove('active-filters');
      }
    }
    if(isMargielaBody) {
      getCustomerWishlist();
    }
  },

    applyFilterEnter: function () {
      const isMarniBody = document.querySelector('body').dataset.sitebrand == 'Marni';
      if(isMarniBody && !window.isMobile()) {
        $('.container').on('keypress', '.js_refinement-link, .refinement-bar a.reset, .filter-value a, .swatch-filter a', function (event) {
          if (event.key !== 'Enter') return;
          $(event.target).trigger('click');
        });
      }
    },

  //   countValues: function () {
  //     if (!isMobile()) {
  //       $('.js_collapsible').on('click', function (e) {
  //         const valueNumber = $(this).find('.values .value').length;
  //         let containerElementsFilters = $(this).find('.js_container_elements_filters');
  //         let containetGeneral = $('#js_refinements_filter').width();

  //         let $elem = $(containerElementsFilters),
  //           left = $elem.offset().left,
  //           width = $elem.width();

  //         if (left + width > containetGeneral && valueNumber > 8) {
  //           console.log($(this).find('.js_card-body'));
  //           $(this).find('.js_card-body').addClass('container_elements_filters_wrapper');
  //         }

  //         if (valueNumber > 48) {
  //           $('.values').addClass('values-bigger-max-height');
  //         } else {
  //           $('.values').removeClass('values-bigger-max-height');
  //         }
  //       });
  //     }
  //   },

  //   collapsableItems: function () {
  //     const selector = '.js_collapsible .js_total-selected, .js_collapsible .js_title, .js_collapsible .js_card-header, .js_collapsible .js_select-arrow';

  //     document.addEventListener(
  //       'click',
  //       function (e) {
  //         const matchFunction = Element.prototype.matches || Element.prototype.msMatchesSelector;

  //         if (matchFunction.call(e.target, selector)) {
  //           const items = document.querySelectorAll('.js_collapsible');
  //           let parent = e.target;

  //           e.preventDefault();

  //           do {
  //             parent = parent.parentNode;
  //           } while (parent != null && !parent.matches('.js_collapsible'));

  //           let item = null;

  //           for (let i = 0; i < items.length; i++) {
  //             item = items[i];

  //             if (item === parent) {
  //               item.classList.toggle('select-open');
  //               $(item).find('.js_refinement-link').attr('tabindex', '0');
  //             } else {
  //               item.classList.remove('select-open');
  //               $(item).find('.js_refinement-link').attr('tabindex', '-1');
  //               $(item).find('.js_card-body').removeClass('container_elements_filters_wrapper');
  //             }
  //           }

  //           scrollToRefinementBar();
  //         }
  //       },
  //       false
  //     );
  //   },

  //   tabRefinementActivation: function () {
  //     $('.container').on('keyup', '.js_refinement, .js_refinement-link', function (event) {
  //       if (event.key !== 'Tab') {
  //         return;
  //       }

  //       let activeMenu = null;
  //       activeMenu = event.target.closest('.js_refinement');
  //       document.querySelectorAll('.js_refinement').forEach((item) => {
  //         if (item === activeMenu) {
  //           item.classList.add('active');
  //           item.classList.remove('collapsed');
  //         } else {
  //           item.classList.remove('active');
  //           item.classList.add('collapsed');
  //         }
  //       });
  //       scrollToRefinementBar();
  //     });
  //   },

  //   showMoreFilters: showMoreFilters,

  //   baseActions: function () {
  //     const $modalbackground = $('.js_refinement-bar, .modal-background');
  //     const $refinementBar = $('.js_refinement-bar');
  //     const $header = $('.header');

  //     $body.on('click', '.js_filter-sort-results', function () {
  //       $modalbackground.show();

  //       if (isMobile()) {
  //         $header.addClass('z-auto');
  //       }

  //       $refinementBar.addClass('show-refinement-bar');
  //       // disableBodyScroll(document.querySelector('.show-refinement-bar'));
  //     });
  //     $body.on('click', '.js_refinement-bar .js_close, .modal-background, .js_refinement-bar .js_apply-filters', function () {
  //       $modalbackground.hide();

  //       if (isMobile() && $refinementBar.hasClass('show-refinement-bar')) {
  //         // enableBodyScroll(document.querySelector('.show-refinement-bar'));
  //         $body.on('webkitTransitionEnd.filters msTransitionEnd.filters transitionend.filters', $refinementBar, function () {
  //           $header.removeClass('z-auto');
  //           $body.off('.filters');
  //         });
  //       }

  //       $refinementBar.removeClass('show-refinement-bar');
  //     });
  //     $body.on('click', '.js_refinement-bar .js_clear-filters', function () {
  //       $('.js_refinement-bar .js_reset_link').trigger('click');
  //     });
  //   },

  //   sort: function () {
  //     // Toggle class used for animation. Toggle aria-hidden and tab indexes
  //     $body.on('click', '.js_sort-order', function () {
  //       this.classList.toggle('select-open');
  //       const isOpen = this.classList.contains('select-open');
  //       const sortOptions = this.querySelector('.sort-options');
  //       if (!sortOptions) return;
  //       sortOptions.setAttribute('aria-hidden', !isOpen);
  //       $(sortOptions)
  //         .find('.sort-option')
  //         .attr('tabindex', isOpen ? '0' : '-1');
  //     });

  //     // Handle sort order menu selection
  //     // $body.on('click', '.sort-option', function (e) {
  //     //   e.preventDefault();

  //     //   const newLabel = this.innerText;
  //     //   const sortId = this.dataset.id;
  //     //   $.spinner().start();
  //     //   const url = this.dataset.url;
  //     //   ajaxSort(url, newLabel, sortId, plpSwiper);
  //     // });
  //   },

  //   toggleColumnsGrid: toggleColumnsGrid,

  //   applyHash: applyHash,

  //   resizeHandler: function () {
  //     if (isIE11) {
  //       const handler = function () {
  //         const tempMode = isMobile();

  //         if (isCurrentMobile !== tempMode) {
  //           isCurrentMobile = tempMode;

  //           if (isCurrentMobile) {
  //             switchIEGrid(2);
  //           } else {
  //             switchIEGrid();
  //           }
  //         }
  //       };

  //       window.addEventListener('resize', handler);
  //       window.addEventListener('orientationchange', handler);
  //       switchIEGrid();
  //     }
  //   },

  //   showContentTab: function () {
  //     // Display content results from the search
  //     $('.container').on('click', '.content-search', function () {
  //       if ($('#content-search-results').html() === '') {
  //         getContent($(this), $('#content-search-results'));
  //       }
  //     });

  //     // Display the next page of content results from the search
  //     $('.container').on('click', '.show-more-content button', function () {
  //       getContent($(this), $('#content-search-results .result-count'));
  //       $('.show-more-content').remove();
  //     });
  //   },

  //   stickyRefinementsIE: function () {
  //     if (isIE11) {
  //       if ($('.js_refinements-holder').length > 0) {
  //         const targetScroll = $('.js_refinements-holder').position().top;
  //         const $target = $('.js_refinements-holder');
  //         $(window).scroll(function () {
  //           if ($(window).scrollTop() >= targetScroll) {
  //             $target.addClass('js_refinement-sticky-ie');
  //           } else {
  //             $target.removeClass('js_refinement-sticky-ie');
  //           }
  //         });
  //       }
  //     }
  //   },
};
